import { makeStyles } from '@material-ui/core';
import jwt from 'jwt-decode';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AnnouncementIcon from '../../assets/icons/Announcement_Logov3.jpg';
import RoadInfoIcon from '../../assets/icons/Road_Condition_Logov3.jpg';
import Card from '../../components/common/card/card';
import { sampleItems } from "../../utils/NavigationHelper";
import styles from "./Dashboard.module.scss";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: '0px !important'
  },
  section: {
    paddingLeft: "0px"
  }
}));
const Dashboard = props => {
  const classes = useStyles();
  const oidc = useSelector(state => state.oidc);
  const [isRoadsPresent, setRoadsPresent] = useState(false);
  const [isAnnouncementsPresent, setAnnouncements] = useState(false);

  useEffect(() => {
    if (oidc.user?.access_token) {
      const user = jwt(oidc?.user?.access_token);
      const roles = user['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];

      roles.map((role) => {
        if ('DGRP_IVR_Integration_Roads' === role) {
          setRoadsPresent(true);
        }
        else if ("DGRP_IVR_Integration_Opal" === role
          || "DGRP_IVR_Integration_TMC" === role
          || "DGRP_IVR_Integration_TrainLink" === role
          || "DGRP_IVR_Integration_Transport" === role) {
          setAnnouncements(true);
        }
      });
    }
  }, [oidc.user?.access_token])
  useEffect(() => {
    if (isRoadsPresent && !isAnnouncementsPresent) {
      window.location.href = '/roads'
    }
    else if (!isRoadsPresent && isAnnouncementsPresent) {
      window.location.href = '/announcements';
    }
    else {
     props.history.push('/');
    }
  }, [isRoadsPresent, isAnnouncementsPresent])

  const renderSection = () => {
    return <div >
      <h3>Transport IVR Messaging Application</h3>
      {/* {renderStatus(finished, step)} */}
      <div className={styles.section + " " + classes.section + " " + classes.noBorder}>
        {isRoadsPresent && isAnnouncementsPresent &&
          <><Card title="Road Conditions Editor"
            imgSrc={RoadInfoIcon}
            cardContent="Road Conditions Editor"
            handleClick={(e) => { e.preventDefault(); window.location.href = '/roads' }} />

            <Card title="Avalanche Announcements"
              imgSrc={AnnouncementIcon}
              cardContent="Avalanche Announcements"
              handleClick={(e) => { e.preventDefault(); window.location.href = '/announcements' }} />
          </>
        }
      </div>
    </div>
  }

  return <div className={styles.mainCont}>
    <div className={'row'}>
      <div className={`col-12`}>
        {renderSection()}
      </div>
    </div>
  </div>
};

export default withRouter(props => <Dashboard {...props} />);
